module.exports = "/_next/static/images/707341f1bbe2f7b43e7db37f3ec7b13f-man-looking-up-smiling-md@2x.jpg";